import Phaser from 'phaser';
import { FONT_BOLD } from '../../constants/AppConstants';

export default class ScreenRotate extends Phaser.Group {
  constructor(game) {
    super(game);

    this.bg = this.game.make.image(0, 0, 'background_rotate');
    this.addChild(this.bg, 0);

    this.container = this.game.make.group();
    this.addChild(this.container);

    // rotate
    this.rotateIcon = this.game.make.image(0, 0, 'rotate_device');
    this.rotateIcon.anchor.set(0, 0);
    this.container.add(this.rotateIcon);

    this.message = this.game.make.text(0, 0, '', {
      font: '22px Arial',
      fill: '#FFFFFF',
      boundsAlignH: 'center',
      boundsAlignV: 'top',
      align: 'center',
      wordWrap: true,
      wordWrapWidth: this.rotateIcon.width,
    });

    this.divider = this.game.make.image(0, 0, 'rotate_divider');
    this.divider.anchor.set(0.5, 0);
    this.divider.y = this.rotateIcon.height + 20;
    this.divider.x = this.rotateIcon.width * 0.5;
    this.container.add(this.divider);

    // set level text - if < level 4 display level, else display gold level
    this.message.text = this.game.copy.getCopy('rotate_message');
    this.message.setTextBounds(this.rotateIcon.width * 0.05, 0, this.rotateIcon.width * 0.9);
    this.message.y = this.divider.y + this.divider.height + 20;
    this.container.add(this.message);

    this.container.contentWidth = this.rotateIcon.width;
    this.container.contentHeight = this.message.y + this.message.height;

    this.resumeGame = false;
    this.positionContainer();
  }

  positionContainer(game) {
    this.bg.width = this.game.width;
    this.bg.height = this.game.height;

    this.container.x = this.game.width * 0.5 - this.container.contentWidth * 0.5;
    this.container.y = this.game.height * 0.5 - this.container.contentHeight * 0.5;
  }

  activateScreen(game) {
    game.hud.setScreenIsRotated(true);
    game.stage.addChildAt(this, game.stage.children.length); // add rotate screen at very top
    this.screenActive = true;
    this.visible = true;
    this.positionContainer(game);
    this.resumeGame = false;
    if (game.hud.isGameScreen() && !game.paused) {
      this.resumeGame = true;
      game.controller.pauseGame();
    }
  }

  deactivateScreen(game) {
    game.hud.setScreenIsRotated(false);
    this.screenActive = false;
    this.visible = false;
    game.stage.removeChild(this);
    if (this.resumeGame === true) {
      game.controller.resumeGame();
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/display/ui/ScreenRotate.js